export default {
	in: [
		{
			url: 'Visa/Mastercard',
			active: false,
			remark: 'C01',
			isGlcash: true,
		},
	],
	sa: [
		//沙特
		{
			url: 'Visa/Mastercard',
			active: false,
			remark: 'C01',
			isGlcash: true,
		},
	],
	ae: [
		// 阿联酋
		{
			url: 'Visa/Mastercard',
			active: false,
			remark: 'C01',
			isGlcash: true,
		},
	],
	kw: [
		// 科威特
		{
			url: 'Visa/Mastercard',
			active: false,
			remark: 'C01',
			isGlcash: true,
		},
	],
	qa: [
		// 卡塔尔
		{
			url: 'Visa/Mastercard',
			active: false,
			remark: 'C01',
			isGlcash: true,
		},
	],
	eg: [
		// 埃及
		{
			url: 'Visa/Mastercard',
			active: false,
			remark: 'C01',
			isGlcash: true,
		},
	],
	tr: [
		// 土耳其
		{
			url: 'Visa/Mastercard',
			active: false,
			remark: 'C01',
			isGlcash: true,
		},
	],
	bh: [
		// 巴林
		{
			url: 'Visa/Mastercard',
			active: false,
			remark: 'C01',
			isGlcash: true,
		},
	],
	jo: [
		// 约旦
		{
			url: 'Visa/Mastercard',
			active: false,
			remark: 'C01',
			isGlcash: true,
		},
	],
	om: [
		// 阿曼
		{
			url: 'Visa/Mastercard',
			active: false,
			remark: 'C01',
			isGlcash: true,
		},
	],
	ma: [
		// 摩洛哥
		{
			url: 'Visa/Mastercard',
			active: false,
			remark: 'C01',
			isGlcash: true,
		},
	],
	us: [
		// 美国
		{
			url: 'Visa/Mastercard',
			active: false,
			remark: 'C01',
			isGlcash: true,
		},
		// {
		// 	url: 'MyBank',
		// 	active: false,
		// 	remark: 'C01',
		// },
	],
	ca: [
		// 加拿大
		{
			url: 'Visa/Mastercard',
			active: false,
			remark: 'C01',
			isGlcash: true,
		},
	],
	gb: [
		// 英国
		{
			url: 'Visa/Mastercard',
			active: false,
			remark: 'C01',
			isGlcash: true,
		},
		// {
		// 	url: "Paysafecard Paysafecash",
		// 	active: false,
		// 	remark: 'C01',
		// }
	],
	de: [
		// 德国
		{
			url: 'Visa/Mastercard',
			active: false,
			remark: 'C01',
			isGlcash: true,
		},
		// {
		// 	url: 'Giropay',
		// 	active: false,
		// 	remark: 'C01',
		// },
	],
	fr: [
		// 法国
		{
			url: 'Visa/Mastercard',
			active: false,
			remark: 'C01',
			isGlcash: true,
		},
	],
	be: [
		// 比利时
		{
			url: 'Visa/Mastercard',
			active: false,
			remark: 'C01',
			isGlcash: true,
		},
	],
	au: [
		// 澳大利亚
		{
			url: 'Visa/Mastercard',
			active: false,
			remark: 'C01',
			isGlcash: true,
		},
	],
	other: [
		{
			url: 'Visa/Mastercard',
			active: false,
			remark: 'C01',
			isGlcash: true,
		},
	]
}
